<script setup>
import { ref, computed, defineProps, defineEmits } from 'vue';
import InfoBoxBottom from '@/components/cloudCounter/InfoBoxBottom.vue';
import VerificationCodeForEmail from '@/components/cloudCounter/VerificationCodeForEmail.vue';
import ErrorInfoBox from '@/components/cloudCounter/InfoBox.vue'
import { postSentOTP, postVerifyOTP } from '@/apis/ValidEmail';
import Loading from '@/components/Loading.vue';

const props = defineProps({
    closeHandle: Function,
    email: String,
    nextStep: Function,
});

// const emit = defineEmits(['update:verifyCode', 'update:otpCodePre'])

const isCounting = ref(false);
const errorMsg = ref('');
const errorBoxVisble = ref(false);
const errorType = ref('');
const verifyCode = ref('');
const otpCodePre = ref('');
const disableInput = ref(false);
const isLoading = ref(false);

// const inputValue = computed({
//     get() {
//         return props.verifyCode;
//     },
//     set(value) {
//         emit('update:verifyCode', value);
//     }
// })

// const otpCodePreData = computed({
//     get() {
//         return props.otpCodePre;
//     },
//     set(value) {
//         emit('update:otpCodePre', value);
//     }
// })

const disableSubmitBtn = computed(() => {
    return !/^\d{6}$/.test(verifyCode.value)
})

const beginCounting = () => {
    isCounting.value = true;
    verifyCode.value = '';
};

const stopCounting = () => {
    isCounting.value = false;
};

const countSendTimes = (data) => {
    if (data === 3) {
        errorMsg.value = `動態密碼重新補發已達三次，請輸入正確動態密碼或重新申請，謝謝!`;
        errorBoxVisble.value = true;
    }
}

const closeBox = () => {
    if (errorType.value === 'STOP_PROCESS') {
        router.push({ name: routeName.CLOUD_E_COUNTER_HOME });
    }
    errorBoxVisble.value = false;
}

const initData = async () => {
    isLoading.value = true;
    try {
        const sentOTPRes = await postSentOTP(props.email)
        otpCodePre.value = sentOTPRes.data?.otpCodePre
    } catch (ex) { } finally {
        isLoading.value = false;
    }
}
initData();

const validatOTP = async () => {
    isLoading.value = true;
    try {
        const verifyEmailRes = await postVerifyOTP(verifyCode.value, props.email)

        const { verify, cancelTransaction, errorTimes, notMeeting, errorStatus } = verifyEmailRes.data;

        if (verify) {
            props.nextStep();
            return;
        }

        verifyCode.value = '';
        errorMsg.value = '驗證碼錯誤';
        if (cancelTransaction) {
            errorMsg.value = `您所填寫的Email<br>${props.email}<br>驗證失敗，請重新申請，謝謝！`;
            errorType.value = 'STOP_PROCESS';
            return;
        }

        if (errorStatus === '2') {
            verifyCode.value = '';
            errorMsg.value = `驗證碼輸入錯誤，請索取新動態密碼！`;
            disableInput.value = true;
            return;
        }
        errorBoxVisble.value = true;
    } catch (ex) { } finally {
        isLoading.value = false;
    }
}

</script>

<template>

    <InfoBoxBottom boxTitle="E-mail驗證" :closeHandle="closeHandle">
        <p class="pb-2 text-sm">已發送動態密碼至您的 E-mail： {{ email }}</p>
        <div class="pb-6">
            <VerificationCodeForEmail :isImmediate="true" buttonText="索取新動態密碼" :buttonDisabled="isCounting"
                :beginCounting="beginCounting" :stopCounting="stopCounting" title="請輸入 6 碼動態密碼" titleClass=""
                :email="email" :setData="(data) => { otpCodePre = data }"
                :reSendLimit="(data) => { countSendTimes(data) }" :recoverInput="() => { disableInput = false }">
                <span class="flex justify-between items-center pb-2">
                    <p class="text-lg w-1/5">{{ otpCodePre }} -</p>
                    <div class="w-4/5">
                        <input :disabled="disableInput" type="text" placeholder="請輸入 6 碼驗證密碼" maxlength="6" size="6"
                            v-model="verifyCode" />
                        <!-- <p class="text-[#EB4751] pl-3">驗證碼輸入錯誤，請索取新動態密碼</p> -->
                    </div>
                </span>
            </VerificationCodeForEmail>
        </div>

        <ul class="pl-6 pb-10 text-sm text-[#86878F] list-disc">
            <li class="pb-2">系統將於 1-2 分鐘內傳送動態密碼予您。</li>
            <li class="pb-2">動態密碼發送後，需等待60秒方可索取新動態密碼</li>
        </ul>

        <div class="flex w-full max-w-[768px] mx-auto">
            <div class="flex-1 pr-2">
                <div class="cursor-pointer block py-3 text-center rounded bg-[#CCF3FF] text-[#0093C1]"
                    @click="closeHandle">
                    取消
                </div>
            </div>
            <div class="flex-1 pl-2">
                <button
                    class="w-full py-3 text-center rounded bg-[#0093C1] text-white disabled:bg-[#D7D8DA] disabled:text-[#86878F]"
                    :disabled="disableSubmitBtn" @click="validatOTP">確認送出</button>
            </div>
        </div>

    </InfoBoxBottom>
    <ErrorInfoBox v-if="errorBoxVisble" :closeHandel="closeBox" title="系統提示">
        <div v-html="errorMsg" />
    </ErrorInfoBox>
    <Loading :is-loading="isLoading" />
</template>

<style scoped></style>
